export default __webpack_public_path__ + "cm-logo.18093e67.svg";